var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938H513V341.994H0V-0.00585938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.6 122.394H284.5L256.5 73.7942L228.5 122.394H172.4L200.4 170.994L172.4 219.594H228.5L256.5 268.194L284.5 219.594H340.6L312.6 170.994L340.6 122.394ZM293.2 170.994L276 204.194H237.1L219.8 170.994L237 137.794H275.9L293.2 170.994ZM256.5 99.1942L268.4 122.494H244.5L256.5 99.1942ZM198.2 137.794H222.1L211.3 158.794L198.2 137.794ZM198.2 204.194L211.2 182.094L223.1 204.194H198.2ZM256.5 241.694L244.6 219.594H268.5L256.5 241.694ZM315.9 204.194H290.9L302.8 182.094L315.9 204.194ZM289.8 137.794H315.9L302.9 159.894L289.8 137.794ZM0 21.2942H512V63.9942H0V21.2942ZM0 277.294H512V319.994H0V277.294Z",
    fill: "#2E52B2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1001"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIl);
export default __webpack_public_path__ + "static/media/IL.ea85d27985efbed48e5993c303b55587.svg";
export { ForwardRef as ReactComponent };